export default "__VITE_ASSET__zUkajd5O__"